import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import classNames from 'classnames';
import {modules} from './utils'
import AddImage from './AddImage';
import { deleteImgs } from './actions';
import AddVideo from './AddVideo';
import './EditorMedia.scss';
import Spiner from '../../Spiner/Spiner';

const Clipboard = ReactQuill.Quill.import('modules/clipboard');
const Delta = ReactQuill.Quill.import('delta');

class PlainClipboard extends Clipboard {
  onPaste (e) {
    e.preventDefault()
    const range = this.quill.getSelection()
    const text = e.clipboardData.getData('text/plain')
    const delta = new Delta()
    .retain(range.index)
    .delete(range.length)
    .insert(text)
    const index = text.length + range.index
    const length = 0
    this.quill.updateContents(delta, 'silent')
    this.quill.setSelection(index, length, 'silent')
    this.quill.scrollIntoView()
  }
}

ReactQuill.Quill.register('modules/clipboard', PlainClipboard, true)

class EditorMedia extends Component {

  constructor(props) {
    super(props);
    this.state = {
      spiner: false,
    };
    this.refEditor = React.createRef();

    this.deleteImages = [];

    if(props.refEditor){
      props.refEditor = this;
    }

  }
  

  insertImage = (src) => {

    if(this.props.addedImage){
      this.props.addedImage(src)
    }
    if (this.editor) {
      this.editor.focus()
      let range = this.editor.getSelection()
      let index = range && range.index ? range.index : 0
      this.editor.insertEmbed(index, 'image', src, "api")
    }
  }
  
  insertVideo = (src) => {
    if (this.editor) {
      this.editor.focus()
      var range = this.editor.getSelection()
      let index = range && range.index ? range.index : 0
      this.editor.insertEmbed(index, 'video', src, "api")
    }
  }


  getQuillEditor = ref => {
    this.quillRef = ref
    if (this.quillRef) {
      this.editor = this.quillRef.getEditor();
    }
  }

  focusEditor = () => {
    if (this.editor) {
      this.editor.focus();
    }
  }

  render() {
    const {input, label, meta: { touched, error }, hideUpload } = this.props;
    const { spiner } = this.state; 
    return (
      <div className="EditorMedia">
        {spiner && <div className="block-spinner">
          <Spiner />
        </div>}
        
        <div className="actions">
          {label ? <div className='title'>{label}</div> : <div />}
          {!hideUpload && <div>
            <AddImage insertImage={this.insertImage} setSpiner={(status) => this.setState({spiner: status})} />
            <AddVideo insertVideo={this.insertVideo} />
          </div>}
        </div>
        <ReactQuill
          value={input.value}
          ref={this.getQuillEditor}
          onChange={(value) => {
            input.onChange(value)
          }}
          modules = {modules}
        />
        {touched && ((error && <span style={{color: '#a94442'}}>{error}</span>))}
      </div>
    );
  }
}

export default EditorMedia;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/EditorMedia/EditorMedia.jsx